import { create } from "zustand";
import { PBO_LIST_BRIN } from "../../Utils/constant";
import { find } from "../../services/service";
export const usePortStore = create((set) => ({
  loading: false,
  data: [],
  intention: [],
  getData: async (params) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await find(`${PBO_LIST_BRIN + params}`);
      setTimeout(() => {
        set({
          loading: false,
          data: getItems.data,
        });
      }, 300);
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
